var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.cards),function(card){return _c('v-col',{key:card.title,staticClass:"pa-2",attrs:{"cols":"12","sm":6,"md":card.cols}},[_c('DashCard',{attrs:{"title":card.title,"value":card.value,"valueColor":card.color,"loading":_vm.dashEventLoading}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }